import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

export function getMatchedCardSx(theme: Theme) {
  return {
    bgcolor: alpha(theme.palette.success.main, 0.08),
    border: `1px solid ${alpha(theme.palette.success.main, 0.22)}`,
    borderRadius: 2,
    px: 2,
    py: 1.25,
  };
}

export function getMissingCardSx(theme: Theme) {
  return {
    bgcolor: alpha(theme.palette.warning.main, 0.08),
    border: `1px solid ${alpha(theme.palette.warning.main, 0.24)}`,
    borderRadius: 2,
    px: 2,
    py: 1.25,
  };
}

export function getUnmatchedCardSx(theme: Theme) {
  return {
    bgcolor: alpha(theme.palette.grey[500], 0.06),
    border: `1px solid ${alpha(theme.palette.grey[500], 0.18)}`,
    borderRadius: 2,
    color: 'text.secondary',
    px: 2,
    py: 1.25,
  };
}
